
import { defineComponent } from "vue";

export default defineComponent({
  name: "drawer-content",
  props: {
    name: {
      type: Boolean,
      default: true,
      required: true,
    },
    direction: {
      type: String,
      default: "end",
    },
    toggleButton: {
      type: String,
      required: true,
    },
    closeButton: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "{default:'70%', 'md': '50%'}",
    },
    activate: {
      type: String,
      default: "true",
    },
  },
  setup() {
    return {};
  },
});
